/**
 * Total profit margin on cart lines eligible for referral sharing (cashback cap).
 */
export function calculateCartProfitMargin(cart) {
  let totalProfitMargin = 0;

  for (const item of cart?.items || []) {
    if (item.referralShare) {
      totalProfitMargin +=
        (Number(item.profitMargin) || 0) * (item.quantity || 1);
    }
  }

  for (const pkg of cart?.packages || []) {
    if (pkg.referralShare) {
      const packagePrice = pkg.price || 0;
      const profitMargin =
        pkg.profitMargin != null && pkg.profitMargin !== ""
          ? Number(pkg.profitMargin)
          : packagePrice * 0.1;
      totalProfitMargin += profitMargin * (pkg.quantity || 1);
    }
  }

  return Math.round(totalProfitMargin * 100) / 100;
}
